import { createSrcSet } from '../utils/image';
import { MewsImageProps } from './MewsImageProps';

export const DEFAULT_SOURCE_SET_WIDTHS = [640, 768, 1024, 1366, 1600, 1920];
export const DEFAULT_RATIO = 16 / 9;

export default (Component: React.ComponentType<MewsImageProps>) =>
    ({ src, widthSet = DEFAULT_SOURCE_SET_WIDTHS, ratio = DEFAULT_RATIO, ...other }: MewsImageProps) => (
        <Component {...other} src={src} srcSet={createSrcSet(src, widthSet, ratio)} />
    );
